import CommonOperationClass from '../../../commonOperationClass';

const eight = new CommonOperationClass('8');

export default eight;
